import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import Home from './components/Home';
import Groups from './components/Groups';
import Chat from './components/Chat';
import Profile from './components/Profile';
import Upload from './components/Upload';
import GroupDetail from './components/GroupDetail';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ResetPassword from './components/auth/ResetPassword'; // Yeni bileşen
import Layout from './components/Layout';
import CalendarPage from './components/Calendar';
import NotFound from './components/NotFound';
import ForgotPassword from './components/auth/ForgotPassword';
import VerifyEmail from './components/auth/VerifyEmail';

function App() {
  return (
    <Router>
      <NotificationProvider>
        <div className="App">
          <Routes>
            {/* Layout içinde gösterilecek rotalar */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="groups" element={<Groups />} />
              <Route path="chat" element={<Chat />} />
              <Route path="profile" element={<Profile />} />
              <Route path="upload" element={<Upload />} />
              <Route path="group/:groupId" element={<GroupDetail />} />
              <Route path="calendar" element={<CalendarPage />} />
            </Route>

            {/* Layout dışında gösterilecek rotalar */}
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="verify-email/:token" element={<VerifyEmail />} />
            {/* Bulunamayan sayfalar için catch-all route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </NotificationProvider>
    </Router>
  );
}

export default App;